import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { WhiteLayout, LayoutColumn, WhiteColumnLayout, SectionHeadLayout } from "netcompany-mdx-slide";
import ex_collection_list from "./assets/ex_collection_list.png";
import ex_java_string from "./assets/ex_java_string.png";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <SectionHeadLayout title={"Example\nfrom real projects"} mdxType="SectionHeadLayout" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      